module.exports = __webpack_public_path__ + "img/Free Response 02.7b7a0798.png";